/* eslint-disable import/prefer-default-export */

// If on these pages, on sign out, go to homepage
const signOutToHomepageRoutes = ['/basket']

// If this cookie value is present and on basket, refresh the page on sign out (old behaviour)
const SIGN_OUT_TO_BASKET_COOKIE = 'sign_out_to_basket=true'

export const shouldSignOutToHomepage = (pathname = '', cookies = '') => {
  const hasSignOutToBasketCookie =
    (cookies && cookies.split(';').filter((item) => item.includes(SIGN_OUT_TO_BASKET_COOKIE)).length > 0) || false
  return signOutToHomepageRoutes.includes(pathname) && !hasSignOutToBasketCookie
}
